import { schema } from 'normalizr';

import appointmentsResource from './appointmentsResource';
import appointmentTypesResource from './appointmentTypesResource';
import availabilitiesResource from './availabilitiesResource';
import facilitiesResource from './facilitiesResource';
import patientsResource from './patientsResource';
import providersResource from './providersResource';
import usersResource from './usersResource';

const offersResourceConfig = {
  key: 'offers',
  url: '/offers',
  fetchPageUrl: '/offers/crudList',
  hasFetchBulkSupport: true,
  lookups: {
    user: usersResource,
    provider: providersResource,
    facility: facilitiesResource,
    approvedBy: usersResource,
    declinedBy: usersResource,
    availability: availabilitiesResource,
    createdFromAppointment: appointmentsResource,
    patientFound: patientsResource,
    appointmentType: {
      ...appointmentTypesResource,
      schema: new schema.Array(appointmentTypesResource.schema),
    },
  },
  processStrategy: (data: any) => ({
    ...data,
    $toString: `[${data.status}] ${data.$toString}`,
  }),
};

export default offersResourceConfig;
